import {
    initFormValidation,
    validateField,
    validateForm,
    clearFieldValidation
} from './functions/form-validation.js';

export const formValidation = {
    init: initFormValidation,
    validateField,
    validateForm,
    clearFieldValidation
};

export const exposeFormValidation = (target = (typeof window !== 'undefined' ? window : null)) => {
    if (target) {
        target.IrrobaFormValidation = formValidation;
    }

    return formValidation;
};

if (typeof window !== 'undefined') {
    exposeFormValidation(window);
}

export {
    initFormValidation,
    validateField,
    validateForm,
    clearFieldValidation
};

export default formValidation;
